function initializeSymbolismOriginalVideos(root = document) {
  root.querySelectorAll?.('[data-symbolism-story]:not([data-original-video-ready])').forEach((story) => {
    story.dataset.originalVideoReady = 'true';
    const backgroundVideos = [...story.querySelectorAll('.symbolism-story__media video')];
    const foregroundVideos = [...story.querySelectorAll('.symbolism-story__original-video')];
    const dots = [...story.querySelectorAll('[data-symbolism-dot]')];

    const sync = () => {
      const activeIndex = Math.max(0, dots.findIndex((dot) => dot.classList.contains('is-active')));
      foregroundVideos.forEach((video, index) => {
        video.classList.toggle('is-active', index === activeIndex);
        if (index === activeIndex) {
          const source = backgroundVideos[index];
          if (source && Math.abs(video.currentTime - source.currentTime) > .5) video.currentTime = source.currentTime;
          video.play().catch(() => {});
        } else video.pause();
      });
    };

    new MutationObserver(sync).observe(story, { attributes: true, subtree: true, attributeFilter: ['class'] });
    sync();
  });
}

initializeSymbolismOriginalVideos();
new MutationObserver((mutations) => mutations.forEach((mutation) => mutation.addedNodes.forEach((node) => {
  if (node.nodeType === Node.ELEMENT_NODE) initializeSymbolismOriginalVideos(node);
}))).observe(document.documentElement, { childList: true, subtree: true });
